module.exports = __webpack_public_path__ + "img/gysrmyy.dd8feb9a.png";